module.exports = ".navbar {\n  top: 0; }\n"